<template>
  <el-dialog
    width="450px"
    :title="item && item.id ? '编辑设备' : '新增设备'"
    :visible="show"
    :close-on-click-modal="false"
    top="0"
    class="flex-center"
    @close="handleClose">
    <el-form :model="info" label-width="100px" label-position="left" ref="form">
      <template v-for="(item, index) in form">
        <el-form-item
          :label="item['label']"
          :key="index"
          :prop="item.key"
          :rules="{ required: true, message: `请填写${item.label}`, trigger: 'blur' }">
          <el-input v-model="info[item['key']]"></el-input>
        </el-form-item>
      </template>
      <el-form-item label-width="0" class="dialog-btn-box">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { editDevice } from '../../../../api/monitor';
  export default {
    name: "monitor-device",
    props: {
      show: {
        type: Boolean,
        default: false
      },
      form: {
        type: Array,
        default: () => []
      },
      model: {
        type: String,
        default: ''
      },
      item: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        info: {}
      }
    },
    methods: {
      //  确定
      async handleConfirm() {
        try {
          await this.$refs.form.validate();
          const params = { ...this.info };
          editDevice(params).then(res => {
            this.$emit('success');
            this.handleClose();
          })
          // this.$emit('success', this.info, this.model, this.id);
        } catch (e) {
          return false;
        }
      },
      //  取消
      handleClose() {
        this.$refs.form.resetFields();
        Object.assign(this.$data, this.$options.data());
        this.$emit('close', this.model);
      }
    },
    watch: {
      item(val) {
        if (val.hasOwnProperty('id')) {
          this.info = { ...val };
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-btn-box {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>